import { ArdoqId } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';
import { UserEvent } from './types';
import { ArdoqError } from '@ardoq/common-helpers';
import * as profiling from '@ardoq/profiling';

export enum ForceReloadReason {
  CANNOT_CONNECT_WS = 'cannot_connect_ws',
  DEAD_CONNECTION_WS = 'dead_connection_ws',
  PERMISSIONS_CHANGED = 'permissions_changed',
}

/**
 * Indicate that a websocket connection has been estableshed. Triggered both on
 * initial connection and on successful reconnects.
 */
export const websocketConnected = actionCreator('[sync] websocket connected');

/**
 * Indicate that the user session has expired.
 * Typically triggered on 401 responses, or by websocket messages.
 */
export const sessionExpired = actionCreator('[sync] session expired');

/**
 * Indicate that a new user event has occurred
 */

export const userEvent = actionCreator<UserEvent>('[sync] user event');

export const windowRefocused = actionCreator('[sync] window refocused');

type LoadAggregateWorkspacesPayload = {
  workspaceIds: ArdoqId[];
  transaction: profiling.Transaction;
};

export const loadAggregateWorkspaces =
  actionCreator<LoadAggregateWorkspacesPayload>(
    '[sync] load aggregate workspaces'
  );

export const loadAggregateWorkspacesSucceeded = actionCreator(
  '[sync] load aggregate workspaces succeeded'
);

type LoadAggregateWorkspacesFailedPayload = {
  error: ArdoqError;
};

export const loadAggregateWorkspacesFailed =
  actionCreator<LoadAggregateWorkspacesFailedPayload>(
    '[sync] load aggregate workspaces failed'
  );
